export enum MeasurementType {
    Consumption = 1,
    Demand = 2    
}

export const MeasurementTypeNames = new Map<number, string>([
    [MeasurementType.Consumption, 'Consumption'],
    [MeasurementType.Demand, 'Demand']    
]);